export default function CTASection() {
    return (
      <section className="py-20 px-6 text-center bg-secondary">
        <h2 className="text-3xl font-bold mb-4">Siap Belajar dan Naik Level?</h2>
        <p className="text-lg mb-6 max-w-xl mx-auto">
          Yuk, mulai kursus coding privat pertamamu dan bangun portofolio profesional!
        </p>
        <a target="_blank" rel="noreferrer" href="https://wa.me/6288976323341?text=Halo%20min%2C%20saya%20mau%20daftar%20kursus">
          <button className="bg-primary text-white px-6 py-3 rounded-xl font-semibold hover:bg-accent transition">
            Daftar Sekarang
          </button>
        </a>
      </section>
    );
  }
  